import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { IAppointmentActionResponseDto } from "../Dtos/IAppointmentActionResponseDto";
import { IAppointmentActionResponse } from "../types/IAppointmentActionResponse";

export const confirmAppointmentToken = (
  token: string,
  friendlyUrl: string
): Promise<IAppointmentActionResponse> => {
  return httpService()
    .post<IAppointmentActionResponseDto>(
      `/e-reservation/${friendlyUrl}/appointment/confirm/${token}`
    )
    .then((res) => {
      return {
        ...res,
        startDate: DateObject(res.startDate),
        endDate: DateObject(res.endDate),
        createDate: DateObject(res.createDate),
      };
    });
};

export const confirmAppointmentTokenKey = (tokenId: string) => {
  return `linkConfirmAppointment-${tokenId}`;
};
